<template>

   <div class="row text-center justify-content-center" v-if="!isEditing">
      <h2 class="modal-title"><strong>Testimonial</strong></h2>
   </div>

   <hr v-if="!isEditing" />

   <form ref="testimonialFormRef" @submit.prevent="handleSubmit" class="row g-0" :class="{ 'mx-4': !isEditing }"
      style="gap: 0.5rem">

      <LoadingPage v-if="isLoading"></LoadingPage>

      <div>
         <label>Organisation Logo</label>
         <br>
         <div v-if="isEditing">
            <label v-if="isEditing && image_url != '' && this.testimonial.testimonial_image != undefined"
               class="text-end">
               <i v-if="this.testimonial.testimonial_image.original_file_name == ''" class="small">System Generated File
                  Name: {{ this.testimonial.testimonial_image.file_name }}</i>
               <i v-else class="small">File Name: {{ this.testimonial.testimonial_image.original_file_name }}</i>
            </label>
            <div v-if="image_loading" style="min-width: 600px; min-height: 400px;">
               <LoadingImage v-if="image_loading"></LoadingImage>
            </div>
            <br>
            <!-- :style="{ backgroundImage: hasRendered ?getTestimonialImage(testimonial, 1) }" -->
            <div v-if="image_url != ''" class="image-render">

               <img class="fill" :src="this.testimonial.testimonial_image.full_link" :id="'image_' + testimonial.id">
               <!-- <div class="fill" :id="'image_' + testimonial.id" :style="{ backgroundImage: image_url }">
               </div> -->
            </div>
         </div>
         <br v-if="isEditing && image_url != ''">
         <div v-if="isEditing && image_url != '' && $store.getters['auth/canEditContentLibrary']" class="testimonial-buttons">
            <button type="button" :class="{ 'active': showNewImageUpload }" :disabled="image_loading"
               @click="showFileUploader('image', !showNewImageUpload)">
               <!-- <div v-if="image_url == ''"><span class="icon"><i class="fa-solid fa-upload"></i></span> Upload Logo
               </div> -->
               <div v-if="image_url != ''"><span class="icon"><i class="fa-solid fa-upload"></i></span> Replace Logo
               </div>
            </button>
         </div>

         <FileUploader v-if="!isEditing && $store.getters['auth/canEditContentLibrary']" ref="testimonialFileRef" :id="'testimonialImage'" :maxUploadMBSize="3000000"
            @fileListChange="handleFileUpload" key="testimonialImage" :acceptedFileType="'jpg,png'"
            :maxUploadItems="1" />
         <label v-if="!isEditing && $store.getters['auth/canEditContentLibrary']" class="text-end">
            <span class="text-danger">*</span><i class="small">Please upload jpg or png file formats only.</i>
         </label>

         <FileUploader v-if="isEditing && showNewImageUpload && $store.getters['auth/canEditContentLibrary']" ref="testimonialFileUpdateRef"
            :id="'testimonialUpdateImage'" :maxUploadMBSize="3000000" @fileListChange="handleFileUpload"
            key="testimonialUpdateImage" :acceptedFileType="'jpg,png'" :maxUploadItems="1" />
         <label v-if="showNewImageUpload && $store.getters['auth/canEditContentLibrary']" class="text-end">
            <span class="text-danger">*</span><i class="small">Please upload jpg or png file formats only.</i>
         </label>
      </div>

      <div v-if="!isEditing">
         <label for="organisation">Organisation <span class="text-danger">*</span></label>
         <select class="form-select" id="organisation" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model.trim="testimonial.organisation_id"
            @blur="v$.testimonial.organisation_id.$touch">
            <option selected disabled :value="-1">Please choose...</option>
            <option v-for="organisation in organisations" :value="organisation.id" :key="organisation.id">{{
               organisation.name
            }}
            </option>
         </select>

         <span class="form-text text-danger"
            v-if="v$.testimonial.organisation_id.$dirty && testimonial.organisation_id <= 0">
            Organisation is required.
         </span>
      </div>

      <div>
         <label for="contactName">Contact Name <span class="text-danger">*</span></label>
         <input type="text" id="contactName" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model.trim="testimonial.contactName"
            @blur="v$.testimonial.contactName.$touch" class="form-control" placeholder="Contact Name" />
         <span class="form-text text-danger" v-if="v$.testimonial.contactName.$error">
            Contact Name is required.
         </span>
      </div>

      <div>

         <label for="contactRole">Contact Role <span class="text-danger">*</span></label>
         <input type="text" id="contactRole" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model.trim="testimonial.contactRole"
            @blur="v$.testimonial.contactRole.$touch" class="form-control" placeholder="Contact Role" />
         <span class="form-text text-danger" v-if="v$.testimonial.contactRole.$error">
            Contact Role is required.
         </span>
      </div>

      <div>
         <label for="testimonialNote">Testimonial <span class="text-danger">*</span></label>
         <div class="testimonial-buttons">
            <button v-if="this.testimonialButtonText" type="button" :class="{ 'active': this.isText }"
               @click="textOrVideo('text')" :disabled="this.testimonial.video.length > 0 || !$store.getters['auth/canEditContentLibrary']"> <span class="icon">☰</span>
               Text</button>
            <button v-if="this.testimonialButtonVideo" type="button" :class="{ 'active': !this.isText }"
               @click="textOrVideo('video')" :disabled="testimonial.testimonial_text.length > 0 || !$store.getters['auth/canEditContentLibrary']">
               <span class="icon">▶</span> Video </button>
         </div>

         <label v-if="!isEditing" class="text-end">
            <span class="text-danger">*</span><i class="small">Please fill in either text or video only.</i>
         </label>

         <textarea v-if="this.isText" class="form-control" id="testimonialNote" :disabled="!$store.getters['auth/canEditContentLibrary']"
            @blur="v$.testimonial.testimonial_text.$touch" v-model.trim="testimonial.testimonial_text"
            placeholder="Write organisation's testimonial" style="height: 100px"></textarea>

         <div v-if="!this.isText">

            <div v-if="video_loading" style="min-width: 600px; min-height: 400px;">
               <LoadingImage v-if="video_loading"></LoadingImage>
            </div>
            <!-- && video_url != '' -->
            <label v-if="isEditing && this.testimonial.testimonial_video != undefined && this.testimonial.testimonial_video.full_link != ''" class="text-end">
               <i class="small">System Generated File Name: {{ this.testimonial.testimonial_video.file_name }}</i>
            </label>
            <!-- video_url != '' -->
            <video v-if="isEditing && this.testimonial.testimonial_video != undefined && this.testimonial.testimonial_video.full_link != ''" width="600" height="300" controls autoplay id="video_"
               :src="this.testimonial.testimonial_video.full_link">
               Your browser does not support the video tag.
            </video>

            <!-- <video v-if="isEditing && video_url != ''" width="600" height="300" controls :id="'video_' + testimonial.id"
               :src="video_url">
               Your browser does not support the video tag.
            </video> -->
            <br>
            <br>
            <div v-if="isEditing && $store.getters['auth/canEditContentLibrary']" class="testimonial-buttons">
               <button type="button" :class="{ 'active': showNewVideoUpload }" :disabled="video_loading"
                  @click="showFileUploader('video', !showNewVideoUpload)">
                  <div v-if="this.testimonial.testimonial_video == undefined || this.testimonial.testimonial_video.full_link == ''"> <span class="icon"><i class="fa-solid fa-upload"></i></span> Upload Video
                  </div>
                  <div v-if="this.testimonial.testimonial_video !== undefined && this.testimonial.testimonial_video.full_link !== ''"> <span class="icon"><i class="fa-solid fa-upload"></i></span> Replace
                     Video</div>
               </button>
            </div>

            <FileUploader v-if="(!isEditing || showNewVideoUpload) && $store.getters['auth/canEditContentLibrary']" ref="testimonialVideoRef" :id="'testimonialVideo'"
               @fileListChange="handleFileUpload" key="testimonialVideo" :acceptedFileType="'mp4'"
               :maxUploadItems="1" />
            <label v-if="(!isEditing || showNewVideoUpload) && $store.getters['auth/canEditContentLibrary']" class="text-end">
               <span class="text-danger">*</span><i class="small">Please upload mp4 format only.</i>
            </label>

            <!-- <div
               v-if="isEditing && showNewVideoUpload && this.testimonial.video != undefined"
               class="testimonial-buttons">
               <button type="button" class="active" @click="replaceVideo()">
                  <span class="icon"><i class="fa-solid fa-upload"></i></span> Replace Video </button>
            </div> -->
         </div>

         <span class="form-text text-danger"
            v-if="v$.testimonial.testimonial_text.$error && v$.testimonial.video.$error">
            At least a text or a video testimonial is required.
         </span>

         <span class="form-text text-danger" v-if="v$.testimonial.testimonial_text.$error && isText && isEditing">
            Text Testimonial is required.
         </span>
      </div>

      <!-- <div class="form-check" style="margin-top: 5px;">
         <input class="form--check-input" type="checkbox" v-model="testimonial.show_on_proposal" id="show_on_proposal" checked>
         <label class="form--check-label" for="show_on_proposal">
            Include on proposals
         </label>
      </div>

      <div class="form-check" style="margin-top: 5px;">
         <input class="form--check-input" type="checkbox" v-model="testimonial.show_on_contract" id="show_on_conrtact" checked>
         <label class="form--check-label" for="show_on_contract">
            Include on contracts
         </label>
      </div> -->

      <div>
         <label for="products">Products</label>
         <VueMultiselect :disabled="!$store.getters['auth/canEditContentLibrary']" style="z-index: 999;" id="products" v-model="testimonial.products" :options="productList"
            :multiple="true" :close-on-select="true" label="display_name" track-by="id" :searchable="false"
            placeholder="Please choose at least one...">
         </VueMultiselect>
      </div>

      <div v-if="$store.getters['auth/canEditContentLibrary']" class="pt-3 pb-3 justify-content-center d-flex" style="gap:0.5rem">
         <button v-if="!isEditing" type="button" class="btn btn-outline-warning" @click="resetForm();">Clear
            fields</button>
         <button v-if="!isEditing" type="submit" class="btn btn-info text-light" @click="createTestimonial()"
            :disabled="disableFormButton()">
            Create </button>
         <button v-if="isEditing" type="button" class="btn btn-info text-light" @click="updateTestimonial()"
            :disabled="disableFormButton()">
            Update </button>
      </div>
   </form>

</template>

<script>
import moment from "moment";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
//import { isEmpty } from '@/plugins/helper.js'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import FileUploader from '@/components/FileUploader.vue';
import LoadingPage from '@/components/Utilities/vertex-loading.vue'
import LoadingImage from '@/components/Utilities/vertex-loading-image.vue'
//import VideoSource from '@/components/Utilities/video-source.vue'

export default {

   components: {
      VueMultiselect,
      FileUploader,
      LoadingPage,
      LoadingImage
      //VideoSource,
   },

   setup() {
      return { v$: useVuelidate() }
   },

   props: {
      item: {
         type: Object,
         // required: true,
      },
   },

   emits: ['onSubmit', 'onEditSubmitForm'],

   data() {
      return {
         isLoading: false,
         currentDate: null,
         testimonial: {
            images: [],
            images_update: [],
            dateCreated: null,
            contactName: '',
            organisation_id: -1,
            organisation_name: null,
            contactRole: '',
            testimonial_text: '',
            video: [],
            products: [],
            testimonial_image: {},
            testimonial_video: {},
            //show_on_proposal: true,
            //show_on_contract: false
         },
         organisations: [],
         contactRoles: [],
         productList: [],
         isEditing: false,
         isFromReplace: false,
         isFromReplaceVideo: false,
         showNewImageUpload: false,
         showNewVideoUpload: false,
         hasRenderedImage: false,
         hasRenderedVideo: false,
         isText: true,
         video_id: "",
         image_id: "",
         image_url: "",
         video_url: "",
         testimonialButtonText: true,
         testimonialButtonVideo: true,
         isEdited: true,
         image_loading: false,
         video_loading: false,
      }
   },

   validations() {

      const mustBeGreaterThan0 = (value) => value > 0

      return {
         testimonial: {
            contactName: { required },
            organisation_id: { required, mustBeGreaterThan0 },
            contactRole: { required },
            testimonial_text: {
               required: (value, vm) => {
                  //console.log("here1")
                  //console.log(!vm.testimonial_text == "" || !vm.video.length <= 0)
                  return !vm.testimonial_text == "" || !vm.video.length <= 0;
               },
            },
            video: {
               required: (value, vm) => {
                  //console.log("here2")
                  //console.log(!vm.testimonial_text == "" || !vm.video.length <= 0)
                  return !vm.testimonial_text == "" || !vm.video.length <= 0;
               },
            },
         },
      }
   },

   computed: {

   },

   watch: {
      isText(value) {
         if (value) {
            this.testimonial.video = []
         } else {
            if (!this.isEditing)
               this.testimonial.testimonial = ""
         }
      },
      //   'testimonial.testimonial'(val) {
      //       console.log(val)
      //   }
   },

   created() {
      this.init()
   },

   methods: {
      init() {
         this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getProductList()
         //check first if there are auth organisation list
         if (this.organisations.length < 1) {
            this.getAuthOrganisations()
         }
      },

      isCreate() {
         this.isEditing = false
      },

      isEdit(id) {
         this.isEditing = true
         this.getTestimonial(id)

         // Keep track of the original data
         this._beforeEditingCache = Object.assign({}, this.testimonial);
      },

      handleSubmit() {

      },

      async getTestimonial(id) {
         this.isLoading = true;
         await this.$axios.get("/testimonials/" + id)
            .then((response) => {

               let responseTestimonial = response.data.testimonial
               this.testimonial.contactName = responseTestimonial.contact_name
               this.testimonial.contactRole = responseTestimonial.contact_role
               this.testimonial.testimonial_text = responseTestimonial.testimonial
               this.testimonial.organisation_id = responseTestimonial.organisation_id
               this.testimonial.testimonial_image = responseTestimonial.testimonial_image
               this.testimonial.testimonial_video = responseTestimonial.testimonial_video
               this.testimonial.organisation_name = responseTestimonial.organisation_name

               if (this.testimonial.testimonial_image == undefined && this.testimonial.testimonial_image == null) {
                  this.showNewImageUpload = true;
               } else if (this.testimonial.testimonial_image.file_name == "" || this.testimonial.testimonial_image.file_extension == "" || this.testimonial.testimonial_image.full_link == "") {
                  this.showNewImageUpload = true;
               }

               if (this.testimonial.testimonial_video == undefined && this.testimonial.testimonial_video == null) {
                  this.showNewVideoUpload = true;
                  this.testimonialButtonVideo = false;
                  this.isText = true
               }



               if (this.testimonial.testimonial_text == undefined || this.testimonial.testimonial_text == "") {
                  this.testimonialButtonText = false;
                  this.isText = false;
               }

               this.testimonialButtonText = false;
               this.testimonialButtonVideo = false;

               if (responseTestimonial.products != undefined && responseTestimonial.products.length > 0) {
                  this.testimonial.products = []
                  responseTestimonial.products.forEach(p => {
                     this.testimonial.products.push({
                        id: p.product_id.toString(),
                        display_name: p.Product.display_name
                     })
                  })
               }
               

               if (!this.hasRenderedImage) {
                  this.getTestimonialImage(responseTestimonial, 2)
                  this.hasRenderedImage = true
               }

               if (!this.hasRenderedVideo) {
                  this.getTestimonialVideo(responseTestimonial)
                  this.hasRenderedVideo = true
               }

               if (this.isFromReplace) {
                  this.isFromReplace = false
                  this.getTestimonialImage(responseTestimonial, 2)
               }

               if (this.isFromReplaceVideo) {
                  this.isFromReplaceVideo = false
                  this.getTestimonialVideo(responseTestimonial)
               }

               this.isLoading = false;
            })
            .catch((error) => {
               this.isLoading = false;
               console.log(error)
               //this.$toast.error(error)
            })

      },


      handleFileUpload({ type, files }) {
         if (type == "testimonialImage") {
            this.testimonial.images = files
         }
         if (type == "testimonialVideo") {
            this.testimonial.video = files
         }
         if (type == "testimonialUpdateImage") {
            this.testimonial.images_update = files
         }
      },

      showFileUploader(type, value) {
         if (type == 'image') {
            this.showNewImageUpload = value
         } else if (type == 'video') {
            this.showNewVideoUpload = value
         }
      },

      hasBeenEdited() {
         return this.isEdited
      },

      resetForm() {
         this.v$.$reset()
         this.testimonial.contactName = ""
         this.testimonial.contactRole = ""
         this.testimonial.organisation_id = -1
         this.testimonial.testimonial_text = ""
         this.testimonial.images = []
         this.testimonial.video = []
         this.testimonial.products = []
         this.video_id = ""
         this.image_id = ""
         this.video_url = ""
         this.image_url = ""
         this.isText = true

         if (this.$refs.testimonialFileRef != undefined)
            this.$refs.testimonialFileRef.resetForm()
         if (this.$refs.testimonialVideoRef != undefined)
            this.$refs.testimonialVideoRef.resetForm()
         if (this.$refs.testimonialFileUpdateRef != undefined)
            this.$refs.testimonialFileUpdateRef.resetForm()
      },

      //added block type async function
      async getContactRoles() {
         await this.$axios.get("/categories?name=ContactRole")
            .then((response) => {
               this.contactRoles = response.data.category.subcategories
            })
            .catch((error) => {
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      textOrVideo(type) {
         if (type === "text") {
            this.isText = true
         } else if (type === "video") {
            this.isText = false
         }
      },

      disableFormButton() {
         return false
      },

      async getAuthOrganisations() {
         await this.$axios_auth.get("/vertex/organisations")
            .then((response) => {
               this.organisations = response.data.organisations
            })
            .catch((error) => {
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      async createTestimonial() {

         this.v$.$validate();

         if (this.v$.$error) {
            return;
         }

         this.isLoading = true;
         let testimonial = {
            organisation_id: this.testimonial.organisation_id,
            organisation_name: this.GetOrganisationName(this.testimonial.organisation_id),
            contact_name: this.testimonial.contactName,
            contact_role: this.testimonial.contactRole,
            //constact_role_id: "just_for_now",
            //testimonial_images: this.testimonial.images,
            //tetimonial: this.testimonial.testimonial_text,
            //testimonial_videos: this.testimonial.video,
            testimonial: this.testimonial.testimonial_text
         }

         testimonial.products = []
         this.testimonial.products.forEach((p) => {
            testimonial.products.push({
               product_id: p.id.toString()
            })
         })

         testimonial.testimonial_image = {}

         if (this.testimonial.images != undefined && this.testimonial.images.length >= 1) {
            let img = this.testimonial.images[0]
            testimonial.testimonial_image = {
               encoded_file: img.encoded,
               file_name: img.name,
               file_extension: img.extension,
            }
         }

         testimonial.testimonial_videos = {}

         if (this.testimonial.video != undefined && this.testimonial.video.length >= 1) {
            let vid = this.testimonial.video[0]
            testimonial.testimonial_video = {
               encoded_file: vid.encoded,
               file_name: vid.name,
               file_extension: vid.extension,
            }
         }


         //previous implementation
         //testimonial.testimonial_image = []
         // this.testimonial.images.forEach((s) => {
         //    testimonial.testimonial_images.push({
         //       encoded_file: s.encoded,
         //       file_name: s.name,
         //       file_extension: s.extension,
         //    })
         // })

         //previous implementation
         // testimonial.testimonial_videos = []
         // this.testimonial.video.forEach((s) => {
         //    testimonial.testimonial_videos.push({
         //       encoded_file: s.encoded,
         //       file_name: s.name,
         //       file_extension: s.extension,
         //    })
         // })

         await this.$axios.post("/testimonials", testimonial)
            .then((response) => {
               if (response.data.success) {
                  this.$toast.success(response.data.message)
                  this.$emit('onSubmit')
               } else {
                  this.resetForm();
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
         this.isLoading = false;
         this.resetForm();
      },

      async getProductList() {
         await this.$axios.get("/categories?name=Products")
            .then((response) => {
               this.productList = []
               response.data.category.subcategories.forEach((p) => {
                  // let displayName = this.productList.filter(e => {return e.id == p.product_id}).map(e => (e.display_name)).toString()
                  this.productList.push({
                     id: p.id,
                     display_name: p.display_name
                  })
               })

            })
            .catch((error) => {
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      GetOrganisationName(org_id) {
         const organisation = this.organisations.find(org => org.id === org_id);
         return organisation ? organisation.name : null; // Or handle the case where no match is found
      },

      getTestimonialImage(testimonial) {
         this.image_loading = true
         if (testimonial.testimonial_image == undefined && testimonial.testimonial_image == null) {
            this.showNewImageUpload = true
            this.image_loading = false
            return
         }

         if (testimonial.testimonial_image.file_extension == "" || testimonial.testimonial_image.file_name == "") {
            this.showNewImageUpload = true
            this.image_loading = false
         }

         if (testimonial.testimonial_image !== undefined && testimonial.testimonial_image !== null) {
            if (testimonial.testimonial_image.id !== "" && testimonial.testimonial_image.file_extension !== "" && testimonial.testimonial_image.full_link !== null && testimonial.testimonial_image.full_link !== "") {
               this.image_id = testimonial.testimonial_image.id
               this.image_url = `url(${testimonial.testimonial_image.full_link})`
               this.image_loading = false
               // this.getTestimonialImageFromBackend(testimonial.testimonial_image.id, testimonial.id)
            }
         }


         // if (testimonial.testimonial_image !== undefined && testimonial.testimonial_image !== null) {
         //    if (testimonial.testimonial_image.id !== "" && testimonial.testimonial_image.file_extension !== "") {
         //       this.image_id = testimonial.testimonial_image.id
         //       this.getTestimonialImageFromBackend(testimonial.testimonial_image.id, testimonial.id)
         //    }
         // }
         this.image_loading = false
      },

      getTestimonialVideo(testimonial) {
         this.video_loading = true
         if (testimonial.testimonial_video == undefined && testimonial.testimonial_video == null) {
            this.video_loading = false
            return
         }

         // if (testimonial.testimonial_video.file_extension == "" || testimonial.testimonial_video.file_name == "") {
         //    this.showNewImageUpload = true
         //    this.image_loading = false
         // }

         if (testimonial.testimonial_video !== undefined && testimonial.testimonial_video !== null) {
            if (testimonial.testimonial_video.id !== "" && testimonial.testimonial_video.file_extension !== "" && testimonial.testimonial_video.full_link !== null && testimonial.testimonial_video.full_link !== "") {
               this.video_id = testimonial.testimonial_video.id
               
               this.video_url = `url(${testimonial.testimonial_video.full_link})`
               this.video_loading = false
               
               //this.getTestimonialVideoFromBackend(testimonial.testimonial_video.id, testimonial.id)
            }
         }

         this.video_loading = false


         // if (testimonial.testimonial_video !== undefined && testimonial.testimonial_video !== null) {
         //    if (testimonial.testimonial_video.id !== "" && testimonial.testimonial_video.file_extension !== "") {
         //       this.video_id = testimonial.testimonial_video.id
         //       this.getTestimonialVideoFromBackend(testimonial.testimonial_video.id, testimonial.id)
         //    }
         // }
      },

      getFirstVideo(testimonial) {
         if (testimonial.testimonial_videos !== undefined) {
            testimonial.testimonial_videos.forEach(video => {
               if (video.id !== "" && video.file_extension != "") {
                  this.video_id = video.id
                  this.getTestimonialVideo(video.id, testimonial.id)
                  return
               }
            })
         }
      },

      async getTestimonialVideoFromBackend(id, uuid) {
         try {
            if (id == undefined && uuid == undefined)
               return

            const response = await this.$axios.get(`/testimonials/video/${id}`);

            const videoData = response.data.videoData;
            const videoType = response.data.videoType;

            var binaryString = Buffer.from(videoData, 'base64');
            var arrayBuffer = new Uint8Array(binaryString).buffer; // Create an ArrayBuffer
            var blob = new Blob([arrayBuffer], { type: videoType });
            this.video_url = window.URL.createObjectURL(blob);
            this.video_loading = false
         } catch (error) {
            console.error("Error fetching video:", error);
            this.video_loading = false
            return error;
         }
      },

      async getTestimonialImageFromBackend(id, uuid) {
         try {

            if (id == undefined && uuid == undefined)
               return

            const response = await this.$axios.get(`/testimonials/image/${id}`);

            const imageData = response.data.imageData;
            const imageType = response.data.imageType;

            this.image_url = `data:${imageType};base64,${imageData}`
            this.image_loading = false
         } catch (error) {
            console.error("Error fetching image:", error);
            this.image_loading = false
            return error;
         }
      },

      async updateTestimonial() {

         this.v$.testimonial.contactName.$touch();
         this.v$.testimonial.contactRole.$touch();

         if (this.isText) {
            this.v$.testimonial.testimonial_text.$touch();
         }

         if ((this.v$.testimonial.contactName.$error || this.v$.testimonial.contactRole.$error) && !this.isText) {
            return; // Stop submission if there are errors in those fields
         }

         if ((this.v$.testimonial.contactName.$error || this.v$.testimonial.contactRole.$error) && this.isText) {
            if (this.v$.testimonial.testimonial_text.$error)
               return; // Stop submission if there are errors in those fields
         }

         if (this.isText && this.testimonial.testimonial_text == "") {
            return
         }

         if (this.testimonial.contactName == "") {
            return
         }

         if (this.testimonial.contactRole == "") {
            return
         }

         this.isLoading = true
         let testimonial = {
            contact_name: this.testimonial.contactName,
            contact_role: this.testimonial.contactRole,
            testimonial: this.testimonial.testimonial_text
         }

         testimonial.products = []
         this.testimonial.products.forEach((p) => {
            testimonial.products.push({
               product_id: p.id.toString()
            })
         })


         let testimonial_image_replace = {}

         if (this.testimonial.images_update != undefined && this.testimonial.images_update.length >= 1) {
            let img = this.testimonial.images_update[0]
            testimonial_image_replace = {
               testimonial_id: this.$route.params.id,
               encoded_file: img.encoded,
               file_name: img.name,
               file_extension: img.extension,
            }
            this.isFromReplace = true
            this.showNewImageUpload = false
         }

         let testimonial_video_replace = {}

         if (this.testimonial.video != undefined && this.testimonial.video.length >= 1) {
            let vid = this.testimonial.video[0]
            testimonial_video_replace = {
               testimonial_id: this.$route.params.id,
               encoded_file: vid.encoded,
               file_name: vid.name,
               file_extension: vid.extension,
            }
            this.isFromReplaceVideo = true
            this.showNewVideoUpload = false
         }

         if (this.isFromReplace == false) {
            this.hasRenderedImage = false
         }

         if (this.isFromReplaceVideo == false) {
            this.hasRenderedVideo = false
         }

         let combinedData = {
            testimonial: testimonial,
            testimonial_image_replace: testimonial_image_replace,
            testimonial_video_replace: testimonial_video_replace
         }

         // if (testimonial.products == undefined || testimonial.products.length <= 0) {
         //    this.isFromReplaceVideo = false
         //    this.isFromReplace = false
         //    this.$toast.error("Please select products for testimonial.")
         //    return
         // }

         await this.$axios.put("/testimonials/" + this.$route.params.id, combinedData)
            .then((response) => {
               if (response.data.success) {
                  this.resetForm()
                  this.isEdit(this.$route.params.id)
                  this.isLoading = false
                  this.$emit("onEditSubmitForm")
                  this.$toast.success(response.data.message)
               } else {
                  this.isFromReplaceVideo = false
                  this.isFromReplace = false
                  this.isLoading = false
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.isFromReplaceVideo = false
               this.isFromReplace = false
               this.isLoading = false
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      async replaceImage() {

         let testimonial_images = []
         this.testimonial.images_update.forEach((s) => {
            testimonial_images.push({
               testimonial_id: this.$route.params.id,
               id: this.image_id,
               encoded_file: s.encoded,
               file_name: s.name,
               file_extension: s.extension,
            })
         })

         let tempImageID = this.image_id

         // if (testimonial_images != undefined && testimonial_images.length <= 0) {
         //    this.$toast.error("Please select image to upload for testimonial.")
         //    return
         // }

         //this.resetForm();

         if (tempImageID != "") {
            await this.$axios.put("/testimonials/replace/image/" + this.$route.params.id, testimonial_images)
               .then((response) => {
                  if (response.data.success) {
                     //this.isFromReplace = true
                     //this.isEdit(this.$route.params.id)
                     this.showNewImageUpload = false
                     //this.$toast.success(response.data.message)
                  } else {
                     //this.$toast.error(response.data.message)
                  }
               })
               .catch((error) => {
                  console.error(error)
                  //this.$toast.error(error.response.data.message)
               })
         } else {
            await this.$axios.post("/testimonials/replace/image/" + this.$route.params.id, testimonial_images)
               .then((response) => {
                  if (response.data.success) {
                     //this.isFromReplace = true
                     //this.isEdit(this.$route.params.id)
                     this.showNewImageUpload = false
                     //this.$toast.success(response.data.message)
                  } else {
                     //this.$toast.error(response.data.message)
                  }
               })
               .catch((error) => {
                  console.error(error)
                  //this.$toast.error(error.response.data.message)
               })
         }

      },
      async replaceVideo() {
         let testimonial_videos = []
         this.testimonial.video.forEach((s) => {
            testimonial_videos.push({
               testimonial_id: this.$route.params.id,
               id: this.video_id,
               encoded_file: s.encoded,
               file_name: s.name,
               file_extension: s.extension,
            })
         })

         let tempVideoID = this.video_id

         // if (testimonial_videos != undefined && testimonial_videos.length <= 0) {
         //    this.$toast.error("Please select video to upload for testimonial.")
         //    return
         // }

         //this.resetForm();

         if (tempVideoID != "") {
            await this.$axios.put("/testimonials/replace/video/" + this.$route.params.id, testimonial_videos)
               .then((response) => {
                  if (response.data.success) {
                     //this.isFromReplaceVideo = true
                     //this.isEdit(this.$route.params.id)
                     this.showNewVideoUpload = false
                     //this.$toast.success(response.data.message)
                  } else {
                     //this.$toast.error(response.data.message)
                  }
               })
               .catch((error) => {
                  console.error(error)
                  //this.$toast.error(error.response.data.message)
               })
         } else {
            await this.$axios.post("/testimonials/replace/video/" + this.$route.params.id, testimonial_videos)
               .then((response) => {
                  if (response.data.success) {
                     //this.isFromReplaceVideo = true
                     //this.isEdit(this.$route.params.id)
                     this.showNewVideoUpload = false
                     //this.$toast.success(response.data.message)
                  } else {
                     this.$toast.error(response.data.message)
                  }
               })
               .catch((error) => {
                  //console.error(error)
                  this.$toast.error(error.response.data.message)
               })
         }

      }
   },
};

</script>

<style scoped>
.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #F3994D;
}

select>option {
   color: #435666;
   /* border: 1px solid #D9D9D9; */
   /* border-radius: 5px; */
}

.btn {
   width: 7rem;
}

form label:not(#isCharityLbl) {
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]),
select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.form--check-label {
   /* Adjust spacing between checkbox and label */
   color: #495057 !important;
   /* Grayish color for the label */
}

.form--check-input {
   width: 20px;
   /* Increase width */
   height: 20px;
   /* Increase height */
   margin-left: -17px;
   margin-right: 10px;
   background-color: #00A0C1;
}

input[type=checkbox]{
    accent-color: #00A0C1;
}

.add-space {
   margin-bottom: 225px;
}

/* For testimonial buttons */
.testimonial-buttons {
   display: flex;
   /* Arrange buttons horizontally */
}

.testimonial-buttons button {
   background-color: whitesmoke;
   /* Teal background color */
   color: #00A0C1;
   border: none;
   padding: 8px 16px;
   /* Add some padding */
   cursor: pointer;
   /* Indicate clickable */
   font-weight: bold;
   border-radius: 4px !important;
   /* Slightly rounded corners */
   margin-right: 5px;
   /* Add space between buttons */
   margin-bottom: 5px;
}

.testimonial-buttons button.active {
   background-color: #00A0C1;
   color: whitesmoke;
   /* Darker teal for active state */
}

.testimonial-buttons .icon {
   margin-right: 5px;
   /* Space between icon and text */
}

.image-render {
   /* height: 400px;
   width: 400px; */
   /* width: 100%;
   height: 100%; */
   /* background-size: cover; */
   /* background-position: center;
   width: 100%;
   height: 100%; */
}

/* .fill {
   background-size: cover;
   background-position: center;
   width: 100%;
   height: 100%;
} */

.fill {
   /* background-size: cover; */
   object-fit: fill;
   /* background-position: center; */
   width: 100%;
   height: 100%;
}
</style>